import React, { useEffect, useState } from 'react'
import { Select, Tag, Typography, message } from 'antd'
import Modal from '../../components/common/modal/modal'

const { Text } = Typography

// Local part and domain must each contain a letter, so numeric-only junk is rejected.
const EMAIL_PATTERN = /^(?=[^@]*[A-Za-z][^@]*@)(?!\.)(?!.*\.\.)[A-Za-z0-9._%+-]+(?<!\.)@(?=[^@]*[A-Za-z])[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}$/

const isValidEmail = (email) => typeof email === 'string' && EMAIL_PATTERN.test(email.trim())

const NotificationSettingsModal = ({ open, ccEmails, loading = false, saving = false, onSave, onClose }) => {
  const [emails, setEmails] = useState(ccEmails)

  useEffect(() => {
    if (open) setEmails(ccEmails)
  }, [open, ccEmails])

  const handleEmailsChange = (values) => {
    const added = values.filter(value => !emails.includes(value))
    const invalidAdded = added.filter(value => !isValidEmail(value))
    if (invalidAdded.length > 0) {
      message.error(`Invalid email address${invalidAdded.length > 1 ? 'es' : ''}: ${invalidAdded.join(', ')}`)
    }
    setEmails(values.filter(value => !invalidAdded.includes(value)).map(value => value.trim()))
  }

  const renderEmailTag = ({ label, value, closable, onClose }) => (
    <Tag
      color={value === undefined || isValidEmail(value) ? undefined : 'error'}
      closable={closable}
      onClose={onClose}
      style={{ marginInlineEnd: 4 }}
    >
      {label}
    </Tag>
  )

  const handleOk = () => {
    if (loading) return
    const uniqueEmails = [...new Map(
      emails.map(email => email.trim()).filter(Boolean).map(email => [email.toLowerCase(), email])
    ).values()]
    const invalidEmails = uniqueEmails.filter(email => !isValidEmail(email))
    if (invalidEmails.length > 0) {
      message.error(`Invalid email address${invalidEmails.length > 1 ? 'es' : ''}: ${invalidEmails.join(', ')}`)
      return
    }
    onSave(uniqueEmails)
  }

  return (
    <Modal
      title="Alert Emails"
      open={open}
      onOk={handleOk}
      onCancel={onClose}
      okText="Save"
      confirmLoading={saving}
    >
      <Text>CC Email(s)</Text>
      <Select
        mode="tags"
        open={false}
        value={emails}
        loading={loading}
        disabled={loading || saving}
        placeholder={loading ? 'Loading...' : 'Add email addresses to CC'}
        tokenSeparators={[',', ' ']}
        style={{ width: '100%', marginTop: 8 }}
        onChange={handleEmailsChange}
        tagRender={renderEmailTag}
      />
      <Text type="secondary" style={{ display: 'block', marginTop: 8, fontSize: 12 }}>
        These addresses will be CC&apos;d on the email sent every time an inventory movement is created.
      </Text>
    </Modal>
  )
}

export default NotificationSettingsModal
